import { uniq } from 'lodash';
import { RegionType } from '@wix/shoutout-email-model-v3';
import { SectionType } from '../../types';
import { textCssClasses } from '../../sections/section-text';
import { getEmailBackgroundColor } from '../get-email-background-color';
import { mobileFullWidthColumnClassName, mobileNoWrapColumnClassName, } from '../defaults';
import * as utils from './css-utils-top-padding';
import { getAllTextRegions } from './html';
import { getActualSectionPaddingForSmallScreenCss } from './get-section-padding-tweaks-for-small-screen-css';
import { getMobileLineHeightClasses } from './get-mobile-line-height-classes';
import { getMobileFontSizeClasses } from './get-mobile-font-size-classes';
import { getFooterSectionStyle } from './get-footer-section-style';
import { getMixCss, getMixSmallScreenCss, getMobileMixMulticolumnCss, } from './get-mix-section-style';
import { getItemGridSmallScreenCss } from './get-item-grid-section-style';
var _a = getFooterSectionStyle(), footerSmScreen = _a.smScreen, footerLgScreen = _a.lgScreen, footerAllScreen = _a.all;
var getCommonStyleGenerators = function () {
    return {
        smScreen: [
            getActualSectionPaddingForSmallScreenCss,
            getSeparatorTweaksForSmallScreensCss,
            getMobileTypographyClasses,
            getTextSmallScreenCss,
            getColumnSmallScreenCss,
        ],
        lgScreen: [getTopMessageSeparatorLargeScreenSize],
        all: [
            getLinksUnderlineStyle,
            getLinksDefaultColorStyle,
            getButtonDefaultCss,
            getOutlookBgColor,
        ],
    };
};
export var buildGlobalCssWithSectionStyleGenerators = function (cssGeneratorParams) {
    var generateCss = function (generators) {
        return generators.map(function (f) { return f(cssGeneratorParams); }).join(' ');
    };
    var generateMixSmScreenCss = function (sections) {
        return uniq(sections
            .filter(function (section) { return section.type === RegionType.Mix; })
            .map(function (section) { return getMobileMixMulticolumnCss(section); })
            .join(' ')
            .split('}')).join('}');
    };
    var breakPoint = cssGeneratorParams.breakPoint, sections = cssGeneratorParams.sections, buildForMobile = cssGeneratorParams.buildForMobile;
    var commonStyleGenerators = getCommonStyleGenerators();
    var sectionTypesUsed = uniq(sections.map(function (section) { return section.type; }));
    sectionTypesUsed.forEach(function (sectionType) {
        var _a;
        switch (sectionType) {
            case SectionType.footer:
                (_a = commonStyleGenerators.smScreen).push.apply(_a, footerSmScreen);
                commonStyleGenerators.lgScreen.push(footerLgScreen);
                commonStyleGenerators.all.push(footerAllScreen);
                return;
            case SectionType.follow:
                commonStyleGenerators.smScreen.push(getSocialFollowSmScreenCss);
                return;
            case SectionType.mix:
                commonStyleGenerators.smScreen.push(getMixSmallScreenCss);
                commonStyleGenerators.all.push(getMixCss);
                return;
            case SectionType.subscribe:
                commonStyleGenerators.smScreen.push(getSubscribeSmallScreenCss);
                commonStyleGenerators.all.push(getSubscribersSectionStyle);
                return;
            case SectionType.itemGrid:
                commonStyleGenerators.smScreen.push(getItemGridSmallScreenCss);
                return;
            default:
                return;
        }
    });
    var marginPadding = utils.fixTopSpacingOnMobile(sections);
    var smScreenCss = '';
    if (buildForMobile) {
        var regionSpecificMobileCss = generateMixSmScreenCss(sections);
        smScreenCss = "\n    @media only screen and (max-width: " + breakPoint + ") {\n      " + generateCss(commonStyleGenerators.smScreen) + "\n      " + regionSpecificMobileCss + "\n      .html-email-body-section-topSpacer > div {\n        height: 0px!important;\n      }\n      .first-region-section > table > tbody > tr > td {\n        padding-top: " + marginPadding.margin + "px!important;\n      }\n      .first-region-section .html-email-body-column > table > tbody > tr > td {\n        padding-top: " + marginPadding.padding + "px!important;\n      }\n    }\n\n  ";
    }
    return smScreenCss + "\n\n    @media only screen and (min-width: " + breakPoint + ") {\n      " + generateCss(commonStyleGenerators.lgScreen) + "\n    }\n\n    " + generateCss(commonStyleGenerators.all) + "\n  ";
};
function getColumnSmallScreenCss() {
    return "." + mobileFullWidthColumnClassName + " { max-width: 100%!important; }\n    ." + mobileNoWrapColumnClassName + " { max-width: unset!important; }\n  ";
}
function getSeparatorTweaksForSmallScreensCss() {
    return "\n    .social-icon { width: 36px!important; height: 36px!important; }\n    .social-icon-spacer { width: 12px!important; }\n  ";
}
function getTextSmallScreenCss() {
    return "\n    ." + textCssClasses.text + " {\n      padding: 0!important;\n    }\n  ";
}
function getSubscribeSmallScreenCss() {
    return "\n  .html-emails-subscribe-button {\n    padding-top: 15px!important;\n  }\n\n  .html-email-body-column.html-emails-subscribe-input-container > table > tbody > tr > td {\n    padding-bottom: 0px!important;\n  }\n  ";
}
function getLinksUnderlineStyle() {
    return "\n    a, a:visited { text-decoration: none; }\n  ";
}
function getLinksDefaultColorStyle() {
    return "\n    a, a:active, a:visited, a:hover, a:link {\n      color: #109FFF;\n    }\n  ";
}
function getSocialFollowSmScreenCss() {
    return "\n    .social-follow-element > td {\n      padding: 12px!important;\n    }\n    .social-follow-element img {\n      width:36px!important;\n      height:36px!important\n    }\n  ";
}
export function getButtonDefaultCss() {
    return "\n    .html-emails-button > table > tbody > tr > td {\n      overflow: hidden;\n    }\n    .html-emails-button > div > table > tbody > tr > td {\n      overflow: hidden;\n    }\n  ";
}
function getTopMessageSeparatorLargeScreenSize() {
    return ".html-emails-background > tbody > tr > td {padding: 24px 0!important;}";
}
export function getOutlookBgColor(_a) {
    var composerData = _a.composerData;
    var color = getEmailBackgroundColor(composerData);
    return "\n    [class=\"x_html-emails-background\"] {\n      background-color: " + color + "!important;\n    }";
}
function getMobileTypographyClasses(params) {
    var experiments = params.experiments, composerData = params.composerData, sections = params.sections;
    var htmls = getAllTextRegions(composerData, sections, experiments);
    return [
        getMobileFontSizeClasses(htmls, params),
        getMobileLineHeightClasses(htmls, params),
    ].join(' ');
}
function getSubscribersSectionStyle() {
    return "\n    .html-emails-subscribe-button-container {\n      overflow: hidden;\n    }\n\n    .html-emails-subscribe-button p {\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n    }\n  ";
}
//# sourceMappingURL=build-global-css.js.map